import { render, staticRenderFns } from "./programa-add.vue?vue&type=template&id=60a8a562"
import script from "./programa-add.vue?vue&type=script&lang=js"
export * from "./programa-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports